import { defineModule } from '../../manifest.js';
/**
 * C-1, the split model. The shared AI Gateway is mandatory Platform Core and is
 * declared here as a REQUIRED CORE capability, not as something this add-on
 * provides. The add-on is a product surface; it is never an alternative route
 * to a model, and buying it grants no access to a module the tenant has not
 * bought — cross-module orchestration is doubly gated.
 */
export const manifest = defineModule({
    moduleKey: 'ai-automation',
    name: 'AI & Automation',
    description: 'Agents, automation and workflow design, cross-module orchestration, advanced AI ' +
        'operations, and AI administration and analytics.',
    kind: 'add_on',
    sellable: true,
    navigationModuleKey: 'ai-automation',
    features: [
        { key: 'ai_automation.agents', description: 'Agents with multi-step autonomy' },
        { key: 'ai_automation.workflow_design', description: 'Automation and workflow design' },
        {
            key: 'ai_automation.cross_module_orchestration',
            description: 'Flows spanning entitled modules',
        },
        {
            key: 'ai_automation.advanced_operations',
            description: 'Prompt versioning, evaluation, routing policy',
        },
        {
            key: 'ai_automation.administration',
            description: 'Per-module AI spend, budgets and kill switches',
        },
    ],
    editions: [
        {
            code: 'ed_01',
            description: 'Agents and workflow design',
            features: ['ai_automation.agents', 'ai_automation.workflow_design'],
            limits: ['user', 'transaction'],
        },
        {
            code: 'ed_02',
            description: 'Adds orchestration, advanced operations and administration',
            features: [
                'ai_automation.agents',
                'ai_automation.workflow_design',
                'ai_automation.cross_module_orchestration',
                'ai_automation.advanced_operations',
                'ai_automation.administration',
            ],
            limits: ['user', 'active_user', 'transaction'],
        },
    ],
    limitTypes: ['user', 'active_user', 'transaction'],
    meteredEvents: [
    // Declared empty deliberately. This module is REGISTERED, not implemented:
    // what it meters is a decision that belongs to the stage that builds it,
    // and inventing metric keys now would put names into entitlement and
    // billing records before anybody designed them (S4-6).
    ],
    requiredCore: ['tenancy', 'identity', 'authz', 'audit', 'ai_gateway', 'events', 'jobs'],
    optionalModules: [],
    integrationDeps: [],
    lifecycle: 'proposed',
    commercialRelease: 'later',
    version: 1,
});
//# sourceMappingURL=module.manifest.js.map